module.exports = __webpack_public_path__ + "img/icon_campamento.62e8bfd7.svg";